// extracted by mini-css-extract-plugin
module.exports = {"talkswrapper":"talks-16-1_talkswrapper_1xnqq","spinAround":"talks-16-1_spinAround_1BLmn"};